// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-22b24065]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.im-loading-wrap[data-v-22b24065]{bottom:0;left:0;position:absolute;right:0;top:0;z-index:2021}.im-loading-wrap .loading-content[data-v-22b24065]{left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}.im-loading-wrap .loading-content img[data-v-22b24065]{max-height:40px;max-width:40px;min-height:20px;min-width:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
